import { createTheme } from '@mui/material/styles';
import { spacing, palette } from './constants';
import { MuiAppBar } from './appBar';
import { MuiButton } from './button';
import { MuiCard } from './card';
import { MuiDialog, MuiDialogActions, MuiDialogContent, MuiDialogTitle, } from './dialog';
import { MuiIconButton } from './iconButton';
import { MuiMenuItem } from './menuItem';
import { MuiPaper } from './paper';
import { MuiPopover } from './popover';
import { MuiTabs, MuiTab } from './tabs';
import { MuiTextField } from './textfield';
import { MuiSelect } from './select';
import { MuiSnackbar } from './snackbar';
import { typography, MuiTypography } from './typography';
import { MuiFormControl, MuiFormControlLabel } from './formControl';
export const theme = createTheme({
    spacing,
    palette,
    typography,
    components: {
        MuiAppBar,
        MuiButton,
        MuiCard,
        MuiDialog,
        MuiDialogActions,
        MuiDialogContent,
        MuiDialogTitle,
        MuiFormControl,
        MuiFormControlLabel,
        MuiIconButton,
        MuiMenuItem,
        MuiPaper,
        MuiPopover,
        MuiSelect,
        MuiSnackbar,
        MuiTab,
        MuiTabs,
        MuiTextField,
        MuiTypography,
    },
});
